import type MvAdressResult from "models/MvAddressResult";
import type { RequestParams } from "./addressQueries";

const withQuery = (apiBasePath: string, params: RequestParams) => {
    const query = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
        if (value != null) query.append(key, String(value));
    }
    const serialized = query.toString();
    if (!serialized) return apiBasePath;
    const url = apiBasePath.split("#", 1)[0];
    return `${url}${url.includes("?") ? "&" : "?"}${serialized}`;
};

const request = async (url: string, options: RequestInit) => {
    const headers = new Headers(options.headers);
    // Preserve Axios's same-origin CSRF cookie forwarding for embedding hosts.
    if (typeof document !== "undefined") {
        const token = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/);
        if (
            token &&
            new URL(url, document.baseURI).origin === window.location.origin
        )
            headers.set("X-XSRF-TOKEN", decodeURIComponent(token[1]));
    }
    const response = await fetch(url, { ...options, headers });
    if (!response.ok)
        throw new Error(`Request failed with status code ${response.status}`);
    return response;
};

const accept = "application/json, text/plain, */*";

export const getLocations = async function (
    apiBasePath: string,
    params: RequestParams,
    signal?: AbortSignal,
): Promise<{ data: MvAdressResult[] }> {
    const response = await request(withQuery(apiBasePath, params), {
        headers: { Accept: accept },
        signal,
    });
    return response.json();
};

export const postLog = async function (apiBasePath: string, object: unknown) {
    try {
        await request(withQuery(apiBasePath, { c: "log" }), {
            method: "POST",
            headers: { Accept: accept, "Content-Type": "application/json" },
            body: JSON.stringify(object),
        });
    } catch (e) {
        console.log("postLog error");
        console.log(e);
    }
};
